import { render, staticRenderFns } from "./icon-group.vue?vue&type=template&id=422974f4&scoped=true&lang=pug&"
import script from "./icon-group.vue?vue&type=script&lang=js&"
export * from "./icon-group.vue?vue&type=script&lang=js&"
import style0 from "./icon-group.vue?vue&type=style&index=0&id=422974f4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422974f4",
  null
  
)

export default component.exports